// Kiểu dữ liệu + hằng số cho báo giá (InquiryFee) theo thread trong chat inquiry per-item.
// Nguồn: claude-doc/inquiry-fee.feed.md.

// Loại phí / option_type của thread (khớp option UI + enum backend).
export const INQUIRY_FEE_TYPE = {
  OPERATION_CHECK: 'operation_check', // 追加検品
  CLEANING: 'cleaning', // 清掃
  ACCESSORY_ADD: 'accessory_add', // 付属品追加
  REPAIR: 'repair', // 修理・補修
  OTHER: 'other', // その他手数料
} as const;

export type InquiryFeeType = (typeof INQUIRY_FEE_TYPE)[keyof typeof INQUIRY_FEE_TYPE];

// Tiêu đề JP cho từng loại phí (fallback OTHER).
export const INQUIRY_FEE_TITLE_MAP: Record<string, string> = {
  [INQUIRY_FEE_TYPE.OPERATION_CHECK]: '追加検品',
  [INQUIRY_FEE_TYPE.CLEANING]: '清掃',
  [INQUIRY_FEE_TYPE.ACCESSORY_ADD]: '付属品追加',
  [INQUIRY_FEE_TYPE.REPAIR]: '修理・補修',
  [INQUIRY_FEE_TYPE.OTHER]: 'その他手数料',
};

// Trạng thái vòng đời báo giá.
export const FEE_STATUS = {
  PROPOSED: 'PROPOSED',
  PAID: 'PAID',
  COMPLETED: 'COMPLETED',
  SUPERSEDED: 'SUPERSEDED',
  CANCELED: 'CANCELED',
} as const;

export type FeeStatus = (typeof FEE_STATUS)[keyof typeof FEE_STATUS];

// Nhãn JP hiển thị trạng thái báo giá.
export const FEE_STATUS_LABEL: Record<string, string> = {
  [FEE_STATUS.PROPOSED]: '見積提示',
  [FEE_STATUS.PAID]: '支払済み',
  [FEE_STATUS.COMPLETED]: '完了',
  [FEE_STATUS.SUPERSEDED]: '無効',
  [FEE_STATUS.CANCELED]: 'キャンセル',
};

// 1 phần tử timeline đã merge sẵn ở backend: message hoặc fee, sort tăng theo `at`.
export interface ThreadTimelineItem {
  kind: 'message' | 'fee';
  at: string;
  data: any;
}

// 1 thread (ItemMessageGroup type=0) kèm timeline merge.
export interface ThreadTimeline {
  itemMessageGroupId: number;
  optionType?: string | null; // null = thread お問い合わせ chung (không phí)
  status?: string;
  timeline: ThreadTimelineItem[];
}
